{
  "DATA_ASSISTANT": {
    "TITLE": "Dataassistent",
    "NEW_CONVERSATION": "+ Ny",
    "LOADING": "Laster...",
    "LOADING_MESSAGES": "Laster meldinger...",
    "THINKING": "Tenker...",
    "UNTITLED": "Samtale uten tittel",
    "NO_CONVERSATIONS": "Ingen samtaler ennå. Klikk på \"+ Ny\" for å starte.",
    "EMPTY_STATE": "Velg en samtale eller opprett en ny for å starte.",
    "PLACEHOLDER": "Hva kan jeg finne ut for deg?",
    "SHOW_SQL": "Vis SQL",
    "NO_ROWS": "Ingen rader returnert.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Slett samtale",
    "DELETE_CONFIRM_DESCRIPTION": "Er du sikker på at du vil slette denne samtalen? Denne handlingen kan ikke angres.",
    "DELETE_CONFIRM_YES": "Slett",
    "REPORTS": "Rapporter",
    "SAVE_TO_REPORT": "Lagre til rapport",
    "NEW_REPORT": "Ny rapport",
    "REPORT_NAME": "Rapportnavn",
    "NO_REPORTS": "Ingen lagrede rapporter ennå",
    "REPORTS_EMPTY_STATE": "Velg en rapport eller opprett en ny.",
    "REPORT_SAVED": "Lagret til rapport",
    "DELETE_REPORT_CONFIRM": "Slett rapport",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Er du sikker på at du vil slette denne rapporten? Alle lagrede elementer fjernes.",
    "DELETE_ITEM_CONFIRM": "Fjern element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Er du sikker på at du vil fjerne dette elementet fra rapporten?",
    "EXPORT_CSV": "Eksporter CSV",
    "REFRESH": "Oppdater",
    "QUERY_RUNNING": "Kjører spørring...",
    "QUERY_FAILED": "Spørringen mislyktes",
    "AUTO_REFRESH": "Automatisk oppdatering",
    "AUTO_REFRESH_NONE": "Manuell",
    "AUTO_REFRESH_30S": "30 sekunder",
    "AUTO_REFRESH_1M": "1 minutt",
    "AUTO_REFRESH_5M": "5 minutter",
    "AUTO_REFRESH_10M": "10 minutter",
    "EDIT_MESSAGE": "Rediger melding",
    "RENAME_REPORT": "Gi rapporten nytt navn",
    "RENAME_ITEM": "Gi elementet nytt navn",
    "MOVE_UP": "Flytt opp",
    "MOVE_DOWN": "Flytt ned",
    "COLLABORATORS": {
      "BUTTON": "Samarbeidspartnere",
      "TITLE": "Samarbeidspartnere for rapport",
      "DESCRIPTION": "Velg hvilke agenter og team som kan se denne rapporten.",
      "AGENTS": "Agenter",
      "TEAMS": "Team",
      "SELECT_AGENTS": "Velg agenter",
      "SELECT_TEAMS": "Velg team",
      "SAVE": "Lagre",
      "SAVED": "Samarbeidspartnere oppdatert",
      "SAVE_FAILED": "Kunne ikke oppdatere samarbeidspartnere"
    }
  }
}
